module.exports = __webpack_public_path__ + "static/media/millimetres2mountains.dd731915.png";